import React from "react";
import { DefaultActivityView } from "@components/Activity";

const QuizView = ({ options = [], setModalState }) => (
  <DefaultActivityView options={options} setModalState={setModalState} />
);

export default QuizView;
